import { initI18n } from '@argo/common/i18n'

// The exchange's own words; the shared ones (sign-in, registration, the PIN)
// live in @argo/common/i18n.
export { setLanguage } from '@argo/common/i18n'

const mn = {
  accounts: 'Данс', exchange: 'Арилжаа', ramp: 'Орлого/Зарлага', events: 'Гүйлгээ',
  tabRamp: 'Касс',
  forgotPin: 'Нууц үг мартсан бол админд хандана уу',
  fee: 'Шимтгэл', youReceive: 'Таны авах дүн',
  feeNote: '{{pct}}% шимтгэл суутгасны дараа та авах нь:',
  symbol: 'Валют', to: 'Хүлээн авагч',
  add: 'Нэмэх',
  child: 'Нэр', kind: 'Төрөл',
  send: 'Шилжүүлэх', mint: 'Гаргах', burn: 'Устгах',
  deposit: 'Орлого', withdraw: 'Зарлага', deposits: 'Орлого, зарлагын түүх',
  buy: 'Авах', sell: 'Зарах', qty: 'Тоо хэмжээ',
  available: 'Боломжит', spread: 'Зөрүү', lastPrice: 'Сүүлийн ханш', change: 'Өөрчлөлт',
  high: 'Дээд', low: 'Доод', volume: 'Хэмжээ',
  book: 'Захиалгын дэвтэр', trades: 'Хийгдсэн арилжаа', myOrders: 'Миний захиалга',
  market: 'Зах зээл', side: 'Тал', maker: 'Захиалагч', taker: 'Хүлээн авагч',
  placed: 'Захиалга бүртгэгдлээ', noOrders: 'Нээлттэй захиалга алга',
  noAsks: 'Зарах захиалга алга', noBids: 'Авах захиалга алга',
  enterAmount: 'Дүнгээ оруулна уу', insufficient: 'Үлдэгдэл хүрэлцэхгүй',
  chart: 'График', interval: 'Хугацаа', per: '/', noTradesYet: 'Арилжаа хараахан болоогүй',
  confirmOrder: 'Захиалгаа баталгаажуулна уу',
  confirmBuy: '{{amount}} {{base}}-г нийт {{total}} {{quote}}-өөр авна.',
  confirmSell: '{{amount}} {{base}}-г нийт {{total}} {{quote}}-өөр зарна.',
  txPin: 'Гүйлгээний ПИН',
  currentPin: 'Одоогийн ПИН', newPin: 'Шинэ ПИН',
  pinHint: '4-8 оронтой тоо. Мөнгөн гүйлгээ бүрт шаардана.',
  pinSet: 'Тохируулсан', pinNotSet: 'Тохируулаагүй',
  actAs: 'Данс сонгох (оператор)',
  locus: 'Локус', meta: 'Мэдээлэл', name: 'Нэр', repo: 'Тайлбар',
  enterAccount: 'Данс сонгоно уу',
  // ХХБ (TDB) bank bridge
  payIn: 'Банкаар орлого хийх',
  payInHow: 'Өөрийн холбосон банкны данснаас доорх данс руу шилжүүлнэ үү. Илгээсэн данс тань таныг таниулна — гүйлгээний утга шаардлагагүй.',
  payTo: 'Хүлээн авах данс', accountHolder: 'Эзэмшигч', bankName: 'Банк',
  myBankAccounts: 'Миний банкны данс', linkIban: 'Данс холбох', unlink: 'Салгах',
  linkPending: 'Эхний орлогыг ажилтан шалгана', linkVerified: 'Баталгаажсан',
  noLinks: 'Холбосон данс алга. Орлого хийхээсээ өмнө өөрийн IBAN-аа холбоно уу.',
  payOut: 'Банк руу зарлага',
  payOutHow: 'Зөвхөн өмнө нь орлого хийсэн данс руу. Ажилтан баталсны дараа шилжинэ; тэр хүртэл дүн түгжигдэнэ.',
  noVerified: 'Баталгаажсан данс алга — эхлээд тэр данснаасаа орлого хийнэ үү.',
  requestPayout: 'Зарлага хүсэх', payouts: 'Зарлагын хүсэлт', copy: 'Хуулах', copied: 'Хуулсан',
  st_escrowing: 'Түгжиж байна', st_cancelled: 'Цуцлагдсан', st_requested: 'Хүлээгдэж байна',
  st_sending: 'Илгээж байна', st_sent: 'Шилжсэн', st_burning: 'Шилжсэн', st_completed: 'Дууссан',
  st_failed: 'Банк татгалзсан', st_unknown: 'Шалгаж байна', st_refunding: 'Буцааж байна', st_rejected: 'Татгалзсан',
  st_new: 'Шинэ', st_review: 'Шалгах', st_crediting: 'Тодорхойгүй', st_credited: 'Орсон', st_outgoing: 'Зарлага',
  bankDesk: 'Банкны касс', bankBalance: 'Банкны үлдэгдэл', ledgerSupply: 'Ledger дээрх нийт',
  pollNow: 'Хуулга татах', toReview: 'Шалгах орлого', awaitingPayouts: 'Шийдвэр хүлээж буй зарлага',
  credit: 'Олгох', reject: 'Татгалзах', approve: 'Шилжүүлэх', markSent: 'Шилжсэн', markNotSent: 'Шилжээгүй',
  sender: 'Илгээгч', registeredAs: 'Бүртгэлийн нэр', reasonPrompt: 'Шалтгаан:',
  bankTxnPrompt: 'Хуулган дээрх банкны гүйлгээний дугаар:',
  txidPrompt: 'Ledger дээр энэ mint олдсон бол түүний txid-г, олдоогүй бол хоосон орхино уу:',
  resolve: 'Шийдвэрлэх',
}

const en: typeof mn = {
  accounts: 'Accounts', exchange: 'Exchange', ramp: 'Deposit/Withdraw', events: 'Ledger',
  tabRamp: 'Funds',
  forgotPin: 'Forgot your password? Contact an administrator',
  fee: 'Fee', youReceive: 'You receive',
  feeNote: 'After the {{pct}}% fee you receive:',
  symbol: 'Symbol', to: 'To',
  add: 'Add',
  child: 'Name', kind: 'Kind',
  send: 'Send', mint: 'Mint', burn: 'Burn',
  deposit: 'Deposit', withdraw: 'Withdraw', deposits: 'Deposits & withdrawals',
  buy: 'Buy', sell: 'Sell', qty: 'Amount',
  available: 'Available', spread: 'Spread', lastPrice: 'Last price', change: 'Change',
  high: 'High', low: 'Low', volume: 'Volume',
  book: 'Order book', trades: 'Trades', myOrders: 'My orders',
  market: 'Market', side: 'Side', maker: 'Maker', taker: 'Taker',
  placed: 'Order placed', noOrders: 'No open orders',
  noAsks: 'No sell orders', noBids: 'No buy orders',
  enterAmount: 'Enter an amount', insufficient: 'Not enough balance',
  chart: 'Chart', interval: 'Interval', per: 'per', noTradesYet: 'No trades yet',
  confirmOrder: 'Confirm your order',
  confirmBuy: 'Buy {{amount}} {{base}} for a total of {{total}} {{quote}}.',
  confirmSell: 'Sell {{amount}} {{base}} for a total of {{total}} {{quote}}.',
  txPin: 'Transaction PIN',
  currentPin: 'Current PIN', newPin: 'New PIN',
  pinHint: '4 to 8 digits. Required for every money movement.',
  pinSet: 'Set', pinNotSet: 'Not set',
  actAs: 'Act as account (operator)',
  locus: 'Locus', meta: 'Metadata', name: 'Name', repo: 'Note',
  enterAccount: 'Choose an account',
  // TDB bank bridge
  payIn: 'Deposit by bank transfer',
  payInHow: 'Transfer from a bank account you have linked to the account below. The account you send from is what identifies you — no reference is needed.',
  payTo: 'Pay to', accountHolder: 'Holder', bankName: 'Bank',
  myBankAccounts: 'My bank accounts', linkIban: 'Link account', unlink: 'Unlink',
  linkPending: 'Your first deposit is checked by staff', linkVerified: 'Verified',
  noLinks: 'No linked accounts. Link your IBAN before you deposit.',
  payOut: 'Withdraw to bank',
  payOutHow: 'Only to an account you have deposited from. Sent once staff approve; the amount is held until then.',
  noVerified: 'No verified account yet — deposit from it first.',
  requestPayout: 'Request withdrawal', payouts: 'Withdrawal requests', copy: 'Copy', copied: 'Copied',
  st_escrowing: 'Holding', st_cancelled: 'Cancelled', st_requested: 'Waiting',
  st_sending: 'Sending', st_sent: 'Sent', st_burning: 'Sent', st_completed: 'Completed',
  st_failed: 'Refused by bank', st_unknown: 'Being checked', st_refunding: 'Returning', st_rejected: 'Rejected',
  st_new: 'New', st_review: 'Review', st_crediting: 'In doubt', st_credited: 'Credited', st_outgoing: 'Outgoing',
  bankDesk: 'Bank desk', bankBalance: 'Bank balance', ledgerSupply: 'On the ledger',
  pollNow: 'Read statement', toReview: 'Deposits to review', awaitingPayouts: 'Withdrawals awaiting a decision',
  credit: 'Credit', reject: 'Reject', approve: 'Send', markSent: 'Was sent', markNotSent: 'Was not sent',
  sender: 'Sender', registeredAs: 'Registered as', reasonPrompt: 'Reason:',
  bankTxnPrompt: 'The bank transaction number from the statement:',
  txidPrompt: 'If the ledger shows this mint, its txid; leave empty if it does not:',
  resolve: 'Resolve',
}

export default initI18n({ mn, en })
